var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:{
            '_card-page-base': true,
            '_card-page-base--row': _vm.row,
            '_card-page-base--row--reverse': _vm.reverse
        },attrs:{"flat":""}},[_c('v-card-title',{staticClass:"justify-center"},[_vm._t("icon",null,{"item":_vm.item})],2),_vm._v(" "),_c('v-card-text',{staticClass:"_card-page-base--text"},[_vm._t("text",null,{"item":_vm.item})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bc8931","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-card/app-card-page-item.vue
// module id = null
// module chunks = 